<template>
  <div>
    <div class="p-6 pb-0">
      <BreadCrumbs :navigation="navigation" />
    </div>
    <div class="p-6 pb-0">
      <div class="flex items-center justify-between mb-4">
        <h1 class="text-2xl font-semibold text-gray-900">{{ $t('modules.info-articoli') }}</h1>
      </div>

      <PageServerTable
        :headers="headers" 
        :items="items" 
        :items-per-page.sync="ipp" 
        :items-per-page-options="ippo" 
        :sort-by="sortby" 
        :items-length="total" 
        :reload-fn="reload"
        :page="page"
        show-current-page
        hover
        >
        <template #item.actions="{ item }">
          <div class="flex justify-center">
            <button 
              @click="showInfo(item.Item)"
              class="p-2 text-blue-600 hover:bg-blue-50 rounded-full transition-colors"
              title="Info Articolo"
            >
              <v-icon name="bi-info-circle" scale="1.2" />
            </button>
          </div>
        </template>
      </PageServerTable>
      <div class="pb-24"></div>
    </div>

    <ShowItemInfo 
      :show="showInfoModal" 
      :item="selectedItem" 
      :show-pricelist-info="showPricelistInfo"
      :unit-value-decimals="unitValueDecimals"
      :quantity-decimals="quantityDecimals"
      @close="showInfoModal = false" 
    />
  </div>
</template>

<script>
import { router } from '@inertiajs/vue3';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import PageServerTable from '@/Components/PageServerTable.vue';
import ShowItemInfo from '@/Components/ShowItemInfo.vue';

export default {
  props: ['items', 'total', 'ippo', 'headers', 'ipp', 'page', 'sortby', 'showPricelistInfo', 'unitValueDecimals', 'quantityDecimals'],
  components: {
    BreadCrumbs,
    PageServerTable,
    ShowItemInfo
  },
  data() {
    return {
      navigation: [
        { name: 'Dashboard', href: route('dashboard') },
        { name: this.$t('modules.gestione-magazzino'), href: route('modules.home', 'gestione-magazzino') },
        { name: this.$t('modules.info-articoli'), href: route('modules.gm.infoarticoli') }
      ],
      showInfoModal: false,
      selectedItem: '',
      localHeaders: this.headers,
      localIpp: this.ipp,
      localPage: this.page,
      localSortby: this.sortby
    };
  },
  methods: {
    reload(sortby = undefined, itemsperpage = undefined, page = undefined) {
        if (sortby) this.localSortby = sortby;
        if (itemsperpage) this.localIpp = itemsperpage;
        if (page) this.localPage = page;

        router.post(window.location.href, { 
          headers: this.localHeaders, 
          sortby: this.localSortby, 
          itemsperpage: this.localIpp, 
          page: this.localPage
        }, {
          preserveScroll: true
        });
    },
    showInfo(itemCode) {
      this.selectedItem = itemCode;
      this.showInfoModal = true;
    }
  }
};
</script>
